import { ServicesList } from '../components/ServicesList';

import { useDepartmentStore } from '@/stores/department';

export const ServicesPage = () => {
  const department = useDepartmentStore((state) => state.selected);
  return <ServicesList department={department} />;
};
